export default {
	name: 'Convention.Notifications.Buddies',
	component: 'ConventionNotifications',
	path: 'convention/notifications/buddies',
	meta: {
		auth: true,
		params: {
			buddies: 1
		}
	}
}